module.exports = {"attributes":{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.96967 2.96967C1.26256 2.67678 1.73744 2.67678 2.03033 2.96967L5 5.93934L7.96967 2.96967C8.26256 2.67678 8.73744 2.67678 9.03033 2.96967C9.32322 3.26256 9.32322 3.73744 9.03033 4.03033L5 8.06066L0.96967 4.03033C0.676777 3.73744 0.676777 3.26256 0.96967 2.96967Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
